const CustomerStatistics = () =>
  import('@/views/main/wechatMgmt/customerStatistics/CustomerStatistics.vue')
export default {
  path: '/main/wechatMgmt/customerStatistics',
  name: 'CustomerStatistics',
  component: CustomerStatistics
}
